import axios from '@/libs/api.request'

//发布通知
export const saveShopPublishNotice = async (data) => {
    return axios.request({
        url: '/shop/user/saveShopPublishNotice',
        data,
        method: 'post'
    })

}

//获取所有类型的通知
export const getNoticeInfoByType = async (data) => {
    return axios.request({
        url: '/shop/user/getNoticeInfoByType',
        data,
        method: 'post'
    })

}

//标记通知为已读
export const signNoticeToRead = async (data) => {
    return axios.request({
        url: '/shop/user/signNoticeToRead',
        data,
        method: 'post'
    })

}

//获取未读通知的个数
export const getNotReadNoticeCount = async (data) => {
    return axios.request({
        url: '/shop/user/getNotReadNoticeCount',
        data,
        method: 'post'
    })

}

// 删除公告
export const deleteNotice = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/deleteNotice',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}

// 删除公告
export const noVisitUser = async (that, data) => {
    var res = await axios.request({
        url: '/shop/user/noVisitUser',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getAutoAnnounceSet = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/notice/getAutoAnnounceSet',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const saveAutoAnnounceSet = async (that, data) => {
    var res = await axios.request({
        url: '/shop/notice/saveAutoAnnounceSet',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}
export const getAutoAnnounceSetList = async (that, data) => {
    if (typeof window.localStorage['overallShopToken'] != 'undefined' && window.localStorage['overallShopToken'] != '') {
        data.token = window.localStorage['overallShopToken'];
    }
    var res = await axios.request({
        url: '/shop/notice/getAutoAnnounceSetList',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
        return ;
    }
    return res;
}


